var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeHeart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 253,
    viewBox: "0 0 313 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9577 164.648L43.9799 164.666L44.002 164.683L157.753 250.439L158.5 251L159.232 250.42L264.548 165.425C285.719 150.328 301.18 129.249 308.636 105.277L308.641 105.26C311.319 96.1679 312.408 86.7279 311.864 77.3088V77.2984L311.862 77.288C309.334 43.4087 284.334 14.7666 249.552 5.70364C215.325 -3.21456 178.821 8.69594 157.868 35.534C137.341 7.96418 100.718 -4.82028 65.9298 3.52138C30.5865 11.9961 4.70862 40.466 1.4498 74.6478C0.388692 84.0369 1.20893 93.5304 3.86886 102.635C10.1404 126.683 24.1405 148.33 43.9577 164.648Z",
    fill: "#040612",
    stroke: "#0E9462",
    strokeWidth: 1.86323
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeHeart2);
export default __webpack_public_path__ + "static/media/shape_heart_2.fda8f7b7abce567c1842a6e84456aed7.svg";
export { ForwardRef as ReactComponent };